




























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import rtStep from "@/components/couponcancel/rtStep.vue";
import { Toast } from "vant";

const retreatCouponModule = namespace("retreatCoupon");

@Component({
  components: {}
})
export default class Search extends Vue {
  value: any = "";

  mounted() {
    (this as any).$wechartfunc();
    this.setActive();
  }

  setActive() {
    this.$store.commit("retreatCoupon/setSelectStep", 1);
  }

  async handleSearchClick() {
    if (this.value == "") {
      Toast("请输入会员码/手机号");
      return false;
    }
    const { error, success } = await this.$store.dispatch(
      "retreatCoupon/memberDetail",
      {
        searchText: this.value,
        searchType: 1
      }
    );
    if (success) {
      this.$router.push({
        path: `/retreatCoupon/couponList`,
        query: {
          sancode: this.value,
          type: "1"
        }
      });
    } else {
      const { error, success } = await this.$store.dispatch(
        "retreatCoupon/memberDetail",
        {
          searchText: this.value,
          searchType: 3
        }
      );
      if (success) {
        this.$router.push({
          path: `/retreatCoupon/couponList`,
          query: {
            sancode: this.value,
            type: "3"
          }
        });
      } else {
        Toast(error.msg);
      }
    }
  }
  async handleScanCodeClick() {
    const scanQRCode: any = await (this as any).$wechartfunc("scanQRCode");
    if (scanQRCode) {
      console.log(scanQRCode);
      const { error, success } = await this.$store.dispatch(
        "retreatCoupon/memberDetail",
        {
          searchText: scanQRCode,
          searchType: 1
        }
      );
      if (success) {
        this.$router.push({
          path: `/retreatCoupon/couponList`,
          query: {
            sancode: scanQRCode,
            type: "1"
          }
        });
      } else {
        const { error, success } = await this.$store.dispatch(
          "retreatCoupon/memberDetail",
          {
            searchText: scanQRCode,
            searchType: 3
          }
        );
        if (success) {
          this.$router.push({
            path: `/retreatCoupon/couponList`,
            query: {
              sancode: scanQRCode,
              type: "3"
            }
          });
        } else {
          Toast(error.msg);
        }
      }
    } else {
      return Toast("会员码不存在");
    }
  }
}
